(() => {
  if (window.ggGridThumbnail) return;
  const KEY = 'grid-thumbnail';
  const connected = () => document.documentElement.classList.contains('cp-connected');
  const dialog = document.createElement('dialog');
  dialog.className = 'gg-grid-thumbnail';
  dialog.setAttribute('aria-labelledby', 'grid-thumbnail-title');
  dialog.innerHTML = '<h2 id="grid-thumbnail-title">Grid thumbnail</h2><p data-product></p><label for="grid-thumbnail-choice">Show in collections and racks</label><select id="grid-thumbnail-choice" disabled></select><p>The curator’s note and product-page gallery stay unchanged. Main product photo follows your current main image.</p><p data-status role="status"></p><footer><button type="button" data-cancel>Cancel</button><button type="button" data-save disabled>Save thumbnail</button></footer>';
  document.body.append(dialog);
  const select = dialog.querySelector('select'), status = dialog.querySelector('[data-status]'), save = dialog.querySelector('[data-save]');
  let current = null, busy = false, generation = 0;
  function close() { if (!busy) { generation++; dialog.close(); current?.opener?.focus({preventScroll:true}); } }
  dialog.querySelector('[data-cancel]').onclick = close;
  dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
  async function open(handle, opener) {
    if (!connected() || busy) return;
    const ticket = ++generation;
    current = {handle, opener};
    select.replaceChildren(new Option('Loading…', '')); select.disabled = save.disabled = true;
    dialog.querySelector('[data-product]').textContent = 'Loading product…'; status.textContent = '';
    dialog.showModal();
    try {
      const data = await window.ggComposer.readGridThumbnail(handle);
      if (ticket !== generation || !dialog.open) return;
      const product = data.product;
      current.product = product;
      dialog.querySelector('[data-product]').textContent = product.title;
      select.replaceChildren(new Option('Main product photo (default)', 'photo'));
      const models = (product.media?.nodes || []).filter(m => m.mediaContentType === 'MODEL_3D' && m.status === 'READY');
      models.forEach((m, index) => select.add(new Option(models.length === 1 ? '3D illustration' : `3D illustration ${index + 1} — ${m.alt || 'Model'}`, m.id.split('/').pop())));
      const choice = data.plate?.racks?.[KEY]?.media;
      const legacy = document.documentElement.dataset.curatorGridDefault === 'true' && data.plate?.master?.model && product.media?.nodes?.[1]?.mediaContentType === 'MODEL_3D';
      const selected = choice?.type === 'image' ? 'photo' : choice?.type === 'model' ? String(choice.id) : legacy ? product.media.nodes[1].id.split('/').pop() : 'photo';
      select.value = [...select.options].some(o => o.value === selected) ? selected : 'photo';
      select.disabled = save.disabled = false;
      status.textContent = models.length ? 'This choice applies to this product across all grids.' : 'Add a model using Add 3D, then return here to use it in grids.';
    } catch (error) { if (ticket === generation) status.textContent = error.message || 'Unable to load this product. Try again.'; }
  }
  save.onclick = async () => {
    if (!current?.product || busy) return;
    busy = true; dialog.querySelectorAll('button,select').forEach(el => el.disabled = true); status.textContent = 'Saving thumbnail…';
    try {
      await window.ggComposer.saveGridThumbnail(current.handle, select.value);
      status.textContent = 'Saved across all grids. Reloading the preview…';
      location.reload();
    } catch (error) {
      status.textContent = error.message || 'Not saved. Try again.';
      busy = false; dialog.querySelectorAll('button,select').forEach(el => el.disabled = false);
    }
  };
  function attach(host, handle) {
    if (!host || !handle || host.querySelector(':scope > [data-grid-thumbnail-open]')) return;
    const button = document.createElement('button'); button.type = 'button'; button.className = 'gg-grid-thumb-trigger'; button.dataset.gridThumbnailOpen = '';
    button.title = 'Choose the main photo or 3D illustration for all grids'; button.setAttribute('aria-label', 'Grid thumbnail');
    button.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" aria-hidden="true"><rect x="2" y="2" width="16" height="16"/><path d="M2 10h16M10 2v16"/></svg><span>Grid thumbnail</span>';
    button.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); open(handle, button); });
    host.append(button);
  }
  function scan() {
    if (!connected()) return;
    document.querySelectorAll('.gg-card[data-cp-handle]').forEach(card => attach(card.querySelector('.gg-card__media'), card.dataset.cpHandle));
    const product = document.querySelector('[data-grid-thumbnail-current-product]');
    if (product) document.querySelectorAll('.gg-story__frame, .gg-pdp__gallery').forEach(host => attach(host, product.dataset.gridThumbnailCurrentProduct));
  }
  let queued = false;
  function queue() { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; scan(); }); } }
  new MutationObserver(queue).observe(document.body, {childList:true,subtree:true});
  new MutationObserver(queue).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
  window.addEventListener('gg-composer-account', queue);
  window.ggGridThumbnail = {open}; scan();
})();
